<template>
  <div class="container p-mt-6">
    <h2 class="p-text-center p-mb-5">Estudyoo 1</h2>
    <div class="p-grid p-justify-center">
      <!-- Administrar Usuarios -->
      <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Administrar Usuarios"
          icon="pi pi-users"
          class="p-button-raised p-button-primary w-full"
          @click="irAAdminAlumnos"
        />
      </div>

      <!-- Uso Usuarios -->
      <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Uso Usuarios"
          icon="pi pi-chart-bar"
          class="p-button-raised p-button-info w-full"
          @click="irUsoAlumnos"
        />
      </div>

      <!-- Notificar Usuarios -->
      <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Notificar Usuarios"
          icon="pi pi-bell"
          class="p-button-raised p-button-warning w-full"
          @click="irNotificarAlumnos"
        />
      </div>

      <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Ingreso Masivo Datos"
          icon="pi pi-database"
          class="p-button-raised p-button-success w-full"
          @click="irMasivo"
        />
      </div>

      <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Capitulos No Vigentes"
          icon="pi pi-book"
          class="p-button-raised p-button-success w-full"
          @click="irCapituloNoVigente"
        />
      </div>

       <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Orden Capitulos En Unidades"
          icon="pi pi-book"
          class="p-button-raised p-button-success w-full"
          @click="irCapituloOrden"
        />
      </div>

      <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Preguntas"
          icon="pi pi-book"
          class="p-button-raised p-button-success w-full"
          @click="irPreguntasImagenes"
        />
      </div>

    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  name: 'HomeView',
  setup() {
    const router = useRouter();

    const irIngresoMasivo = () => {
      router.push({
        name: 'ingreso-masivo-alumno',
        query: {
          id_usuario: '3',
          tipo: 'alumno',
          cursos: '1,2,3,4,5,6,7,8,9,10,11,12',
        },
      });
    };

    const irIngresoMasivoProfesor = () => {
      router.push({
        name: 'ingreso-masivo-alumno',
        query: {
          id_usuario: '3',
          tipo: 'profesor',
          cursos: '1,2,3,4,5,6,7,8,9,10,11,12',
        },
      });
    };


    const irPreguntasImagenes = () => {
      router.push({ name: 'reporte-imagenes-preguntas' });
    };

    const irIngresoJefatura = () => {
      router.push({ name: 'ingreso-jefaturas' });
    };

    const irMasivo = () => {
      router.push('/admin-masivo');
    };

    const irAAdminAlumnos = () => {
      router.push('/admin-alumno');
    };

    const irNotificarAlumnos = () => {
      router.push('/notificar-alumnos');
    };

    const irUsoAlumnos = () => {
      router.push('/admin-uso');
    };

    const irCapituloNoVigente = () => {
      router.push('/capitulos-no-vigente');
    };

    const irCapituloOrden = () => {
      router.push('/orden-capitulos-en-unidades');
    };

    

    return {
      irAAdminAlumnos,
      irNotificarAlumnos,
      irUsoAlumnos,
      irIngresoMasivo,
      irIngresoMasivoProfesor,
      irIngresoJefatura,
      irMasivo,
      irCapituloNoVigente,
      irPreguntasImagenes,
      irCapituloOrden,
    };
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.w-full {
  width: 100%;
}

.p-button-raised {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}

.p-button-raised:hover {
  transform: translateY(-2px);
}

.p-text-center {
  color: #333;
  font-weight: 600;
}

@media (max-width: 768px) {
  .p-grid {
    flex-direction: column;
    align-items: center;
  }
}
</style>